import React, { Component } from 'react';

import { Label, Headline, Button } from '../../theme';
import { Slider, Slide } from '../../carousel';
import { Dishwasher } from '../../svg';
import { isMobile } from '../../util';

class DishwasherProblem extends Component {
  render() {
    return (
      <div id="Vase" className="container__fluid">
        <div className="w__flex w__flex-row Justify-between w__flex-column__mobile">

          <div className="w__flex w__flex-column carousel Justify-between Align-center o-2__mobile Align-right__mobile">
            <Slider device="vase">

              <Slide
                text="Procentual, din factura, electrocasnicele cu cel mai mare consum de energie sunt frigiderul (14%), masina de spalat (10%)  si...masina de spalat vase (7%)?"
              />

              <Slide
                text="Atunci cand folosesti masina de spalat la capacitate maxima, speli mai rar si astfel, reduci consumul de energie?"
              />

            </Slider>
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
            </Button>
          </div>

          <div className="w__flex w__flex-column Align-right problem__content">
            <div className="couple">
              <Dishwasher.Couple />
            </div>
            <Label marginRight="5vw" background="#840050" >
              problema MAMEI
            </Label>
            <Headline padding="5vw" large alignRight >
              <p style={{ color: '#840050' }}>SPAL VASELE DUPA</p>
              <p style={{ color: '#840050', zIndex: 1 }}>FIECARE MASA </p>
              <p style={{ color: '#d33c64' }}>...NU ASA E </p>
              <p style={{ color: '#d33c64' }}>NORMAL<span className="punctuation">?</span></p>
            </Headline>
            {
              !isMobile && (
                <div className="tree">
                  <Dishwasher.Tree />
                </div>
              )
            }
          </div>

        </div>
      </div>
    );
  }
}

export default DishwasherProblem;


// WEBPACK FOOTER //
// ./src/components/pages/Vase/DishwasherProblem.jsx